import strings from 'owa-strings/owa-calendar-strings';
import { format } from 'owa-strings';
import { LocationPersonaControlViewState } from 'owa-location-persona';
import shouldRenderCity from 'owa-location-common-well/lib/utils/shouldRenderCity';

export default function getLocationResultAriaLabel(
    location: LocationPersonaControlViewState,
    roomFreeBusyEnabled: boolean
): string {
    let isRoomWithAvailabilityInfo = location.personaType == 'Room' && roomFreeBusyEnabled;
    let secondaryData: string = location.displayAddress;

    if (isRoomWithAvailabilityInfo) {
        let freebusyText = strings.unknownFreeBusy;

        if (location.availability) {
            switch (location.availability) {
                case 'Free':
                    freebusyText = strings.availableFreeBusy;
                    break;
                case 'Busy':
                    freebusyText = strings.showAsBusy;
                    break;
            }
        }

        if (shouldRenderCity(location)) {
            secondaryData = format('{0}, {1}', freebusyText, location.postalAddress.City);
        } else {
            secondaryData = freebusyText;
        }
    }

    return format(strings.locationSelectedAriaLabel, location.displayName, secondaryData);
}
